// 修复后的 modal_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["backdrop", "container"]
    static classes = ["hidden"]

    connect() {
        this.#setupEventListeners()
        // 初始化隐藏状态
        this.backdropTarget.classList.add("opacity-0")
        this.containerTarget.classList.add("opacity-0", "translate-y-4", "sm:translate-y-0", "sm:scale-95")
    }

    handleSubmitEnd(event) {
        // 检查是否有错误信息
        const hasErrors = event.target.querySelector('.rounded-md.bg-red-50') !== null;

        // 检查HTTP状态码（如果可用）
        const isSuccess = event.detail.success && !hasErrors;

        if (isSuccess) {
            this.#clearModal()
        }
        // 如果有错误，保持Modal打开状态，让用户可以看到错误信息并修改输入
    }

    #clearModal() {
        this.#animateOut(() => {
            this.element.classList.add("hidden")
            document.querySelector("turbo-frame#modal").innerHTML = ""
        })
    }

    disconnect() {
        document.removeEventListener("keydown", this.handleEscape)
    }

    closeBackground(event) {
        if (event.target === this.backdropTarget) {
            this.close(event)
        }
    }

    open() {
        this.element.classList.remove("hidden")
        this.#animateIn()
        this.#trapFocus()
    }

    close(event) {
        event?.preventDefault()
        this.#clearModal()
    }

    // 私有方法
    #setupEventListeners() {
        this.handleEscape = this.handleEscape.bind(this)
        document.addEventListener("keydown", this.handleEscape)
    }

    #animateIn() {
        // 背景动画
        this.backdropTarget.classList.remove("opacity-0")
        this.backdropTarget.classList.add("opacity-100")

        // 内容动画
        this.containerTarget.classList.remove(
            "opacity-0",
            "translate-y-4",
            "sm:translate-y-0",
            "sm:scale-95"
        )
        this.containerTarget.classList.add(
            "opacity-100",
            "translate-y-0",
            "sm:scale-100"
        )
    }

    #animateOut(callback) {
        // 背景动画
        this.backdropTarget.classList.remove("opacity-100")
        this.backdropTarget.classList.add("opacity-0")

        // 内容动画
        this.containerTarget.classList.remove(
            "opacity-100",
            "translate-y-0",
            "sm:scale-100"
        )
        this.containerTarget.classList.add(
            "opacity-0",
            "translate-y-4",
            "sm:translate-y-0",
            "sm:scale-95"
        )

        // 严格匹配动画时长
        setTimeout(() => {
            callback?.()
        }, 300) // 匹配 duration-300
    }

    handleEscape(event) {
        if (event.key === "Escape" && !this.element.classList.contains("hidden")) {
            this.close(event)
        }
    }

    #trapFocus() {
        const focusableElements = this.containerTarget.querySelectorAll(
            'a[href], button, textarea, input, select, details, [tabindex]:not([tabindex="-1"])'
        )
        if (focusableElements.length === 0) return

        const firstElement = focusableElements[0]
        const lastElement = focusableElements[focusableElements.length - 1]

        // 实现焦点循环
        this.containerTarget.addEventListener('keydown', (e) => {
            if (e.key === 'Tab') {
                if (e.shiftKey) {
                    if (document.activeElement === firstElement) {
                        lastElement.focus()
                        e.preventDefault()
                    }
                } else {
                    if (document.activeElement === lastElement) {
                        firstElement.focus()
                        e.preventDefault()
                    }
                }
            }
        })

        firstElement.focus()
    }
}